import React, {FC} from "react";
import {useAuth} from "../../config/AuthContext";
import appConfig from "../../config";
import {Trans} from "react-i18next";
import pkg from "../../../package.json";

const SBFooter: FC = () => {

    const {isLoggedIn, isAdmin} = useAuth();

    return (
        <span style={{ paddingRight: "1rem" }}>
            {isLoggedIn && isAdmin ? (<>Backend {appConfig.env} - API {appConfig.apiURL} - </>) : (
                <></>)
            }
            <Trans i18nKey={"Copyright"}/> - {pkg.name} - {pkg.version}
        </span>
    )
}

export default SBFooter;